export const SET_PRICING = 'SET_PRICING'
